import { splitDuration } from '@/features/videos-common/utils/formatDuration';

/**
 * Formats a duration for the home screen: "1 min", "2 min", "1 min 30", or
 * "45 sec" under a minute. Seconds are shown as is (no rounding to the
 * minute). Returns null when the duration is unknown, so callers can hide
 * the badge.
 *
 * @param {number|null|undefined} totalSeconds
 * @param {(key: string, options?: Object) => string} t
 * @returns {string|null}
 */
export default function formatDurationLabel(totalSeconds, t) {
  const parts = splitDuration(totalSeconds);
  if (!parts) return null;

  const { minutes, seconds } = parts;
  if (minutes === 0) return t('home_videos.duration.sec', { seconds });
  if (seconds === 0) return t('home_videos.duration.min', { minutes });
  return t('home_videos.duration.min_sec', { minutes, seconds });
}
